export class ProductosCategorias {
  id: number;
  idProductoCategoria: string;
  idProducto: string;
  idCategoriaMetaAhorro: string;
  indicadorHabilitado: boolean;
  auditoriaFecha: any;
  auditoriaUsuario: string;
  ip: string;
  nombreProducto: string;
  codigoProducto: string;
  nombreCategoriasMetasAhorro: string;
  codigoCategoriasMetasAhorro: string;
  montoMinimo: string;
  montoMaximo: string;
  plazoMinimo: string;
  plazoMaximo: string;
  plazoObligatorio: boolean;
  montoObligatorio: boolean;
}
